import React from 'react';
import { useTranslation } from 'react-i18next';

const Hero: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section id="home" className="relative pt-40 md:pt-44 pb-10 md:pb-16 overflow-hidden bg-[#0c0c0c]" aria-label={t('hero.title1') + ' ' + t('hero.title2')}>
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">

        {/* Headline */}
        <div className="text-center mb-6">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-[1.2] mb-4 md:mb-6">
            <span className="block mb-2">{t('hero.title1')}</span>
            <span className="text-accent-green">{t('hero.title2')}</span>
          </h1>
          <p className="text-gray-400 text-base md:text-lg font-medium mb-3 max-w-3xl mx-auto">
            {t('hero.description1')}
          </p>
          <p className="text-gray-400 text-base md:text-lg max-w-3xl mx-auto leading-relaxed">
            {t('hero.description2')}
          </p>
        </div>

        {/* ========== MOBILE Bento Grid (< md) ========== */}
        <div className="grid grid-cols-2 gap-2.5 mt-8 mb-8 md:hidden">

          {/* Row 1: Photo + Lime card */}
          <div className="aspect-[3/4] rounded-xl overflow-hidden border border-[#2a2a2a] bg-[#161616] shadow-[5px_5px_10px_#0a0a0a,-5px_-5px_10px_#222222]">
            <img src="/stellaON.png" alt="Elektrické zariadenie" className="w-full h-full object-contain scale-125" />
          </div>
          <div className="aspect-[3/4] rounded-xl bg-accent-green p-4 flex flex-col justify-between relative overflow-hidden shadow-[5px_5px_10px_#0a0a0a,-5px_-5px_10px_#222222]">
            <svg className="absolute inset-0 w-full h-full opacity-20" viewBox="0 0 200 200" fill="none">
              <line x1="20" y1="0" x2="20" y2="80" stroke="black" strokeWidth="3" />
              <line x1="40" y1="30" x2="90" y2="30" stroke="black" strokeWidth="2" />
              <line x1="160" y1="130" x2="160" y2="200" stroke="black" strokeWidth="3" />
            </svg>
            <h3 className="relative z-10 text-lg font-bold text-black leading-tight">{t('hero.completeDelivery')}</h3>
            <button className="relative z-10 self-start px-3 py-1.5 bg-black text-white text-[10px] font-medium rounded-full">{t('hero.learnMore')}</button>
          </div>

          {/* Row 2: Big photo spanning full width */}
          <div className="col-span-2 aspect-[2/1] rounded-xl overflow-hidden border border-[#2a2a2a] shadow-[5px_5px_10px_#0a0a0a,-5px_-5px_10px_#222222]">
            <img src="/generator2.jpeg" alt="Energetické riešenie" className="w-full h-full object-cover" />
          </div>

          {/* Row 3: Lime + Lime */}
          <div className="aspect-[3/4] rounded-xl bg-accent-green p-4 flex flex-col justify-between relative overflow-hidden shadow-[5px_5px_10px_#0a0a0a,-5px_-5px_10px_#222222]">
            <svg className="absolute inset-0 w-full h-full opacity-20" viewBox="0 0 200 200" fill="none">
              <line x1="150" y1="0" x2="150" y2="60" stroke="black" strokeWidth="3" />
              <line x1="170" y1="40" x2="200" y2="40" stroke="black" strokeWidth="2" />
            </svg>
            <h3 className="relative z-10 text-lg font-bold text-black leading-tight">{t('hero.designAndPlanning')}</h3>
            <button className="relative z-10 self-start px-3 py-1.5 bg-black text-white text-[10px] font-medium rounded-full">{t('hero.learnMore')}</button>
          </div>
          <div className="aspect-[3/4] rounded-xl bg-accent-green p-4 flex flex-col justify-between relative overflow-hidden shadow-[5px_5px_10px_#0a0a0a,-5px_-5px_10px_#222222]">
            <svg className="absolute inset-0 w-full h-full opacity-15" viewBox="0 0 200 200" fill="none">
              <line x1="10" y1="50" x2="10" y2="150" stroke="black" strokeWidth="3" />
              <line x1="50" y1="20" x2="50" y2="90" stroke="black" strokeWidth="3" />
            </svg>
            <h3 className="relative z-10 text-lg font-bold text-black leading-tight">{t('hero.service247')}</h3>
            <button className="relative z-10 self-start px-3 py-1.5 bg-black text-white text-[10px] font-medium rounded-full">{t('hero.learnMore')}</button>
          </div>

          {/* Row 4: EMS systém + Spoľahlivosť 100% */}
          <div className="aspect-[3/4] rounded-xl bg-accent-green p-4 flex flex-col justify-between relative overflow-hidden shadow-[5px_5px_10px_#0a0a0a,-5px_-5px_10px_#222222]">
            <svg className="absolute inset-0 w-full h-full" viewBox="0 0 200 200" fill="none">
              <line x1="30" y1="30" x2="30" y2="170" stroke="black" strokeWidth="3" opacity="0.3" />
              <line x1="60" y1="20" x2="60" y2="100" stroke="black" strokeWidth="3" opacity="0.3" />
              <line x1="100" y1="60" x2="170" y2="60" stroke="black" strokeWidth="2" opacity="0.25" />
            </svg>
            <h3 className="relative z-10 text-lg font-bold text-black leading-tight">{t('hero.technologies')}</h3>
            <button className="relative z-10 self-start px-3 py-1.5 bg-black text-white text-[10px] font-medium rounded-full">{t('hero.learnMore')}</button>
          </div>
          <div className="aspect-[3/4] rounded-xl bg-accent-green p-4 flex flex-col justify-between relative overflow-hidden shadow-[5px_5px_10px_#0a0a0a,-5px_-5px_10px_#222222]">
            <svg className="absolute inset-0 w-full h-full opacity-25" viewBox="0 0 200 200" fill="none">
              <line x1="40" y1="30" x2="40" y2="100" stroke="black" strokeWidth="3" />
              <line x1="80" y1="50" x2="140" y2="50" stroke="black" strokeWidth="2" />
              <line x1="120" y1="70" x2="120" y2="130" stroke="black" strokeWidth="2" />
              <rect x="60" y="110" width="50" height="4" fill="black" opacity="0.3" />
              <circle cx="160" cy="120" r="15" stroke="black" strokeWidth="2" opacity="0.2" />
            </svg>
            <div className="relative z-10">
              <div className="text-black/50 text-xs font-medium uppercase tracking-wider mb-1">{t('hero.reliability')}</div>
              <div className="text-black font-bold text-2xl">{t('hero.reliabilityPercent')}</div>
            </div>
            <div className="relative z-10">
              <div className="flex items-center gap-2">
                <span className="w-8 h-1 bg-black/20 rounded-full"></span>
                <span className="w-4 h-1 bg-black/40 rounded-full"></span>
              </div>
            </div>
          </div>
        </div>

        {/* ========== TABLET Bento Grid (md → lg) ========== */}
        <div className="hidden md:grid lg:hidden grid-cols-2 gap-3 mt-10 mb-10">
          {/* Row 1: Photo + Lime card */}
          <div className="aspect-[3/4] rounded-xl overflow-hidden border border-[#2a2a2a] bg-[#161616] shadow-[5px_5px_10px_#0a0a0a,-5px_-5px_10px_#222222]">
            <img src="/stellaON.png" alt="Elektrické zariadenie" className="w-full h-full object-contain scale-125" />
          </div>
          <div className="aspect-[3/4] rounded-xl bg-accent-green p-5 flex flex-col justify-between relative overflow-hidden shadow-[5px_5px_10px_#0a0a0a,-5px_-5px_10px_#222222]">
            <svg className="absolute inset-0 w-full h-full opacity-20" viewBox="0 0 200 150" fill="none">
              <line x1="20" y1="0" x2="20" y2="60" stroke="black" strokeWidth="3" />
              <line x1="40" y1="20" x2="80" y2="20" stroke="black" strokeWidth="2" />
              <line x1="160" y1="100" x2="160" y2="150" stroke="black" strokeWidth="3" />
            </svg>
            <h3 className="relative z-10 text-xl font-bold text-black leading-tight">{t('hero.completeDelivery')}</h3>
            <button className="relative z-10 self-start px-4 py-2 bg-black text-white text-xs font-medium rounded-full">{t('hero.learnMore')}</button>
          </div>

          {/* Row 2: Big photo spanning full width */}
          <div className="col-span-2 aspect-[2.5/1] rounded-xl overflow-hidden border border-[#2a2a2a] shadow-[5px_5px_10px_#0a0a0a,-5px_-5px_10px_#222222]">
            <img src="/generator2.jpeg" alt="Energetické riešenie" className="w-full h-full object-cover" />
          </div>

          {/* Row 3: Lime + Lime */}
          <div className="aspect-[3/4] rounded-xl bg-accent-green p-5 flex flex-col justify-between relative overflow-hidden shadow-[5px_5px_10px_#0a0a0a,-5px_-5px_10px_#222222]">
            <svg className="absolute inset-0 w-full h-full opacity-20" viewBox="0 0 200 150" fill="none">
              <line x1="150" y1="0" x2="150" y2="50" stroke="black" strokeWidth="3" />
              <line x1="170" y1="30" x2="200" y2="30" stroke="black" strokeWidth="2" />
            </svg>
            <h3 className="relative z-10 text-xl font-bold text-black leading-tight">{t('hero.designAndPlanning')}</h3>
            <button className="relative z-10 self-start px-4 py-2 bg-black text-white text-xs font-medium rounded-full">{t('hero.learnMore')}</button>
          </div>
          <div className="aspect-[3/4] rounded-xl bg-accent-green p-5 flex flex-col justify-between relative overflow-hidden shadow-[5px_5px_10px_#0a0a0a,-5px_-5px_10px_#222222]">
            <svg className="absolute inset-0 w-full h-full opacity-15" viewBox="0 0 200 150" fill="none">
              <line x1="10" y1="40" x2="10" y2="110" stroke="black" strokeWidth="3" />
              <line x1="50" y1="10" x2="50" y2="70" stroke="black" strokeWidth="3" />
            </svg>
            <h3 className="relative z-10 text-xl font-bold text-black leading-tight">{t('hero.service247')}</h3>
            <button className="relative z-10 self-start px-4 py-2 bg-black text-white text-xs font-medium rounded-full">{t('hero.learnMore')}</button>
          </div>

          {/* Row 4: EMS systém + Empty green rectangle */}
          <div className="aspect-[3/4] rounded-xl bg-accent-green p-5 flex flex-col justify-between relative overflow-hidden shadow-[5px_5px_10px_#0a0a0a,-5px_-5px_10px_#222222]">
            <svg className="absolute inset-0 w-full h-full" viewBox="0 0 200 150" fill="none">
              <line x1="30" y1="30" x2="30" y2="120" stroke="black" strokeWidth="3" opacity="0.3" />
              <line x1="60" y1="20" x2="60" y2="80" stroke="black" strokeWidth="3" opacity="0.3" />
              <line x1="100" y1="50" x2="170" y2="50" stroke="black" strokeWidth="2" opacity="0.25" />
            </svg>
            <h3 className="relative z-10 text-xl font-bold text-black leading-tight">{t('hero.technologies')}</h3>
            <button className="relative z-10 self-start px-4 py-2 bg-black text-white text-xs font-medium rounded-full">{t('hero.learnMore')}</button>
          </div>
          <div className="aspect-[3/4] rounded-xl bg-accent-green shadow-[5px_5px_10px_#0a0a0a,-5px_-5px_10px_#222222]"></div>
        </div>

        {/* ========== DESKTOP Bento Grid (lg+) ========== */}
        <div className="hidden lg:grid grid-cols-10 gap-4 mt-12 mb-12" style={{ gridTemplateRows: '300px 300px' }}>

          {/* Row 1, Col 1-2: Lime "Kompletná dodávka" - LEFT */}
          <div className="col-start-1 col-end-3 row-start-1 row-end-2 rounded-2xl bg-accent-green p-5 flex flex-col justify-between relative overflow-hidden shadow-[5px_5px_10px_#0a0a0a,-5px_-5px_10px_#222222]">
            <svg className="absolute inset-0 w-full h-full opacity-20" viewBox="0 0 200 150" fill="none">
              <line x1="20" y1="0" x2="20" y2="60" stroke="black" strokeWidth="3" />
              <line x1="40" y1="20" x2="80" y2="20" stroke="black" strokeWidth="2" />
              <line x1="160" y1="100" x2="160" y2="150" stroke="black" strokeWidth="3" />
              <line x1="140" y1="120" x2="180" y2="120" stroke="black" strokeWidth="2" />
              <rect x="60" y="90" width="30" height="4" fill="black" />
            </svg>
            <div className="relative z-10">
              <h3 className="text-xl md:text-2xl font-bold text-black leading-tight">
                {t('hero.completeDelivery')}
              </h3>
            </div>
            <button className="relative z-10 mt-3 self-start px-4 py-2 bg-black text-white text-xs font-medium rounded-full hover:bg-gray-800 transition-colors">{t('hero.learnMore')}</button>
          </div>

          {/* Row 1, Col 3-4: Photo - stellaON with navbar background - RIGHT */}
          <div className="col-start-3 col-end-5 row-start-1 row-end-2 rounded-2xl overflow-hidden border border-[#2a2a2a] bg-[#161616] shadow-[5px_5px_10px_#0a0a0a,-5px_-5px_10px_#222222]">
            <img src="/stellaON.png" alt="Elektrické zariadenie" className="w-full h-full object-contain scale-125" />
          </div>

          {/* CENTER: Col 5-8, Row 1-2: BIG photo */}
          <div className="col-start-5 col-end-9 row-start-1 row-end-3 rounded-2xl overflow-hidden border border-[#2a2a2a] shadow-[5px_5px_10px_#0a0a0a,-5px_-5px_10px_#222222]">
            <img src="/generator2.jpeg" alt="Energetické riešenie" className="w-full h-full object-cover" />
          </div>

          {/* Row 1, Col 9-10: Lime "Technológie" */}
          <div className="col-start-9 col-end-11 row-start-1 row-end-2 rounded-2xl bg-accent-green p-5 flex flex-col justify-between relative overflow-hidden shadow-[5px_5px_10px_#0a0a0a,-5px_-5px_10px_#222222]">
            <svg className="absolute inset-0 w-full h-full" viewBox="0 0 200 150" fill="none">
              <line x1="30" y1="30" x2="30" y2="120" stroke="black" strokeWidth="3" opacity="0.3" />
              <line x1="60" y1="20" x2="60" y2="80" stroke="black" strokeWidth="3" opacity="0.3" />
              <line x1="100" y1="50" x2="170" y2="50" stroke="black" strokeWidth="2" opacity="0.25" />
              <line x1="80" y1="90" x2="180" y2="90" stroke="black" strokeWidth="2" opacity="0.25" />
              <rect x="120" y="30" width="40" height="5" fill="black" opacity="0.2" />
              <rect x="130" y="110" width="50" height="5" fill="black" opacity="0.2" />
              <line x1="160" y1="60" x2="160" y2="130" stroke="black" strokeWidth="3" opacity="0.3" />
            </svg>
            <div className="relative z-10">
              <h3 className="text-xl md:text-2xl font-bold text-black leading-tight">
                {t('hero.technologies')}
              </h3>
            </div>
            <button className="relative z-10 mt-3 self-start px-4 py-2 bg-black text-white text-xs font-medium rounded-full hover:bg-gray-800 transition-colors">{t('hero.learnMore')}</button>
          </div>

          {/* Row 2, Col 1-2: Lime "Projektovanie" */}
          <div className="col-start-1 col-end-3 row-start-2 row-end-3 rounded-2xl bg-accent-green p-5 flex flex-col justify-between relative overflow-hidden shadow-[5px_5px_10px_#0a0a0a,-5px_-5px_10px_#222222]">
            <svg className="absolute inset-0 w-full h-full opacity-20" viewBox="0 0 200 150" fill="none">
              <line x1="150" y1="0" x2="150" y2="50" stroke="black" strokeWidth="3" />
              <line x1="170" y1="30" x2="200" y2="30" stroke="black" strokeWidth="2" />
              <rect x="10" y="100" width="25" height="4" fill="black" />
            </svg>
            <div className="relative z-10">
              <h3 className="text-xl md:text-2xl font-bold text-black leading-tight">
                {t('hero.designAndPlanning')}
              </h3>
            </div>
            <button className="relative z-10 mt-3 self-start px-4 py-2 bg-black text-white text-xs font-medium rounded-full hover:bg-gray-800 transition-colors">{t('hero.learnMore')}</button>
          </div>

          {/* Row 2, Col 3-4: Enhanced Lime "Servis 24/7" with stats */}
          <div className="col-start-3 col-end-5 row-start-2 row-end-3 rounded-2xl bg-accent-green p-5 flex flex-col justify-between relative overflow-hidden shadow-[5px_5px_10px_#0a0a0a,-5px_-5px_10px_#222222]">
            <svg className="absolute inset-0 w-full h-full opacity-20" viewBox="0 0 200 150" fill="none">
              <circle cx="160" cy="30" r="20" stroke="black" strokeWidth="2" opacity="0.3" />
              <line x1="150" y1="30" x2="170" y2="30" stroke="black" strokeWidth="2" />
              <line x1="160" y1="20" x2="160" y2="40" stroke="black" strokeWidth="2" />
              <rect x="20" y="100" width="60" height="3" fill="black" opacity="0.2" />
              <rect x="30" y="110" width="40" height="3" fill="black" opacity="0.15" />
            </svg>
            <div className="relative z-10">
              <h3 className="text-lg md:text-xl font-bold text-black leading-tight mb-2">
                {t('hero.service247')}
              </h3>
              <div className="text-black/70 text-xs font-medium">
                {t('hero.responseTime')} <span className="text-black font-bold text-sm">{t('hero.responseTimeValue')}</span>
              </div>
            </div>
            <div className="relative z-10 flex items-center justify-between">
              <div className="flex items-center gap-1">
                <span className="w-2 h-2 bg-red-500 rounded-full animate-pulse"></span>
                <span className="text-black/60 text-xs">{t('hero.nonstop')}</span>
              </div>
              <button className="px-3 py-1.5 bg-black text-white text-xs font-medium rounded-full hover:bg-gray-800 transition-colors">
                {t('hero.learnMore')}
              </button>
            </div>
          </div>

          {/* Row 2, Col 9-10: Green rectangle with decorative pattern */}
          <div className="col-start-9 col-end-11 row-start-2 row-end-3 rounded-2xl bg-accent-green p-5 flex flex-col justify-between relative overflow-hidden shadow-[5px_5px_10px_#0a0a0a,-5px_-5px_10px_#222222]">
            <svg className="absolute inset-0 w-full h-full opacity-25" viewBox="0 0 200 150" fill="none">
              <line x1="40" y1="20" x2="40" y2="80" stroke="black" strokeWidth="3" />
              <line x1="80" y1="40" x2="140" y2="40" stroke="black" strokeWidth="2" />
              <line x1="120" y1="60" x2="120" y2="100" stroke="black" strokeWidth="2" />
              <rect x="60" y="90" width="50" height="4" fill="black" opacity="0.3" />
              <circle cx="160" cy="100" r="15" stroke="black" strokeWidth="2" opacity="0.2" />
            </svg>
            <div className="relative z-10">
              <div className="text-black/50 text-xs font-medium uppercase tracking-wider mb-1">{t('hero.reliability')}</div>
              <div className="text-black font-bold text-2xl">{t('hero.reliabilityPercent')}</div>
            </div>
            <div className="relative z-10">
              <div className="flex items-center gap-2">
                <span className="w-8 h-1 bg-black/20 rounded-full"></span>
                <span className="w-4 h-1 bg-black/40 rounded-full"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
